import React from "react";
import PropTypes from "prop-types";
import CardPublishContent from "../../component-library/CardMeta/CardPublishContent";
import VideoContentCategory from "./VideoContentCategory";

const VideoCardFooter = ({ children = null, className = "" }) => {
  return <div className={`card__footer ${className}`}>{children}</div>;
};

VideoCardFooter.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default Object.assign(VideoCardFooter, {
  ContentCategory: VideoContentCategory,
  PublishContent: CardPublishContent
});
